export const routes = (parentName) => {
  return [
    {
      path: "salary",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Salary`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Salary-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "special",
          name: `${parentName}-Salary-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Salary-New`,
          component: () => import("./Upsert.vue"),
        },

        {
          path: ":id/edit",
          name: parentName + "-" + "Salary-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
